/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.documents.MountSearchOutcome
*/
export var MountSearchOutcome;
(function (MountSearchOutcome) {
    MountSearchOutcome["DELEGATED"] = "DELEGATED";
    MountSearchOutcome["UNSUPPORTED"] = "UNSUPPORTED";
    MountSearchOutcome["UNAVAILABLE"] = "UNAVAILABLE";
})(MountSearchOutcome || (MountSearchOutcome = {}));
//# sourceMappingURL=MountSearchOutcome.js.map